import { action } from 'easy-peasy';
import { IActionSetPersonalData } from '../types';

const setPersonalData: IActionSetPersonalData = action((state, payload) => {
  state.personalData = payload;
});

export default setPersonalData;
